// extracted by mini-css-extract-plugin
export default {"main-container":"Notes_main-container__xCp1t","title-update-container":"Notes_title-update-container__uz8eR","no-notes":"Notes_no-notes__uXAle"};